import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';
import { getAnalytics, isSupported } from 'firebase/analytics';

// Configuração do Firebase - Aruk Dog
const firebaseConfig = {
  apiKey: "AIzaSyAUZaaZkPuimGhhJghxgOiP2avAtet_XqA",
  authDomain: "arukdog-5f983.firebaseapp.com",
  projectId: "arukdog-5f983",
  storageBucket: "arukdog-5f983.firebasestorage.app",
  messagingSenderId: "96532042099",
  appId: "1:96532042099:web:7934c8e3534a8612513506",
  measurementId: "G-5DE8K3E9DD"
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Inicializar serviços
export const db = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);
export let analytics = null;

// Analytics pode falhar fora do browser ou em HTTP não seguro; proteger inicialização
isSupported()
  .then((supported) => {
    if (supported) {
      analytics = getAnalytics(app);
    }
  })
  .catch(() => {
    // Firebase Analytics indisponível
  });

export default app;
